import { Box, Typography, Button, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function Page404() {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          textAlign: 'center',
          gap: 3
        }}
      >
        <Typography variant="h1" sx={{ fontSize: '6rem', fontWeight: 700, color: '#003087' }}>
          404
        </Typography>
        <Typography variant="h5" sx={{ color: '#666666', mb: 2 }}>
          Page Not Found
        </Typography>
        <Typography variant="body1" sx={{ color: '#999999', mb: 3 }}>
          The page you're looking for doesn't exist or has been moved.
        </Typography>
        <Button
          variant="contained"
          onClick={() => navigate('/')}
          sx={{
            background: 'linear-gradient(135deg, #FFCC00 0%, #FFB800 100%)',
            color: '#003087',
            fontWeight: 600,
            textTransform: 'none',
            px: 4,
            py: 1.5,
            '&:hover': {
              background: 'linear-gradient(135deg, #FFD633 0%, #FFCC00 100%)',
            }
          }}
        >
          Go to Home
        </Button>
      </Box>
    </Container>
  );
}

export default Page404;
